import Link from "next/link";
import CoverImage from "../cover-image";
import Date from "../date";

function DefaultBlogPreview({
  title,
  categories,
  coverImage,
  date,
  slug,
}) {
  //const totalcat = categories.edges.length;
  const firstCat = categories.edges[0].node;

  return (
    <Link href={`/${slug}`}>
      <a className="c-card-tow">
        {coverImage && <CoverImage title={title} coverImage={coverImage} />}

        <div className="content-wrapper">
          <div className="c-card-tow-title-wrapper mb-3">
            <div className="news-cat-sec">
              {
                <span className="">
                  <Link href={`${firstCat.uri}`}>
                    <a> {firstCat.name} </a>
                  </Link>
                </span>
              }
            </div>
            <p className="">
              <span>
                <Date dateString={date} />
              </span>
              {/* <ReadingTime content={content} /> */}
            </p>
          </div>
          <article>
            <h3
              className="content-title"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          </article>
        </div>
      </a>
    </Link>
  );
}

export default DefaultBlogPreview;
